module.exports = __webpack_public_path__ + "static/img/sanwei-2.d1418253.png";